var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArgosAssignedAlertsPurple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.44 46.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #89397d;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\xEB\\xEE\\xE9_1",
    "data-name": "\\u2018\\xEB\\xEE\\xE9_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22.02 41.21 19.28 28.98 16.53 41.21 19.28 44.67 22.02 41.21"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1,45.02l1.07-11.63c.31-3.32,2.61-6,5.62-6.54l6.67-1.19,4.91,3,4.91-3,3.53.63"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.37,
    y1: 25.65,
    x2: 15.07,
    y2: 23.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 23.48,
    y1: 23.84,
    x2: 24.19,
    y2: 25.65
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.15,10.03c.82.36.97,1.15.92,2.03l-.07,1.22c-.05.84-.23,1.54-1.02,1.84-.8,3.71-2.98,7.22-6.7,7.22-3.45,0-5.77-3.5-6.65-7.2-.82-.3-1.02-1.01-1.07-1.86l-.07-1.22c-.05-.88.1-1.67.92-2.03,0,0-.36-6.19,1.96-7.43.8-.43-.1-1.2,2.55-1.53,2.2-.28,5.23.23,6.67,1.52,1.01.9,2.74,2.34,2.57,7.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.24,3.92s0,3.52,5.45,1.65c2.96-1.01,6.66-1.54,7.2.95"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.63,20.2c-2.03,2.31-5.14,3.53-8.8,4.3v9.96c0,3.56,1.84,6.8,4.76,8.37l4.04,2.18,4.04-2.18c2.91-1.57,4.76-4.82,4.76-8.37v-9.96c-3.66-.77-6.77-1.99-8.8-4.3Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "36.12 32.71 39.05 35.91 44.44 30.01"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArgosAssignedAlertsPurple);
export default __webpack_public_path__ + "static/media/Argos - Assigned Alerts - Purple.64abde7c45bf973a26a7de448f623548.svg";
export { ForwardRef as ReactComponent };